const CustomerListType = {
	favorites: 'favorites',
	recentlyViewed: 'recentlyViewed',
	wishlist: 'wishlist',
};

export default CustomerListType;
